/**
 * Shared config - Environment variables, constants, feature flags
 */
import { Brand } from '@aegislab/shared';

export const config = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000',
  supabaseUrl: (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? '',
  supabaseAnonKey: (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '',
  appName: Brand.name,
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? '',
} as const;

/** Feature flags — re-export from shared (single source of truth) */
export { featureFlags, isFeatureActive, getViewState } from '@aegislab/shared';
export type { FeatureFlagValue } from '@aegislab/shared';

import { applyFeatureFlagOverrides } from '@aegislab/shared';

// 환경변수로 피처 플래그 오버라이드 (빈 값 = 모든 피처 활성)
const featureFlagsEnv = import.meta.env.VITE_FEATURE_FLAGS as string | undefined;
applyFeatureFlagOverrides(featureFlagsEnv);

/** dev 환경 여부 */
export const isDev = featureFlagsEnv === 'all' || featureFlagsEnv === '';

if (isDev) {
  document.title = '[DEV] AXIOM';
}

/** Branding constants — single source of truth for UI brand strings */
export const brand = {
  name: Brand.name,
  coreBanner: `${Brand.name}::CORE v${__APP_VERSION__}`,
  rankBanner: `${Brand.name}::RANK v0.1 — standby`,
  scenarioTag: `[${Brand.name} - 메인 시나리오]`,
  welcomeMessage: `${Brand.name}에 오신 것을 환영합니다, 플레이어`,
  /** 신원이 확인되면 이름으로, 아니면 "플레이어" 로 부른다 */
  welcome: (playerName?: string) =>
    `${Brand.name}에 오신 것을 환영합니다, ${playerName?.trim() || '플레이어'}`,
  logoAlt: `${Brand.name} Logo`,
} as const;

export * from './constants';
export * from './economy.constants';
export * from './teamOpsKeys';
export * from './viewState';
export * from './appNav';
export * from './windowConfig';
export * from './windowSize';
